import React from 'react'

import { SideSelectContainer, SideSelectItem } from '../../../../../components/shared'

import {
  SearchDocumentHistoryFiltersProps,
  SearchDocumentHistoryFilterType,
} from './SearchDocumentHistoryFilters.model'

export function SearchDocumentHistoryFilters({
  colorPreset = 'dark',
  filter,
  onChange,
}: SearchDocumentHistoryFiltersProps) {
  return (
    <SideSelectContainer>
      <SideSelectItem
        icon="checkCircle"
        active={filter === SearchDocumentHistoryFilterType.ALL}
        colorPreset={colorPreset}
        onClick={() => onChange(SearchDocumentHistoryFilterType.ALL)}
        testId="side_select-document_history-filter-all_versions"
      >
        Toutes les versions
      </SideSelectItem>
      <SideSelectItem
        icon="save_disk"
        active={filter === SearchDocumentHistoryFilterType.HISTORY}
        colorPreset={colorPreset}
        onClick={() => onChange(SearchDocumentHistoryFilterType.HISTORY)}
        testId="side_select-document_history-filter-history"
      >
        Révisions
      </SideSelectItem>
      <SideSelectItem
        icon="documentText"
        active={filter === SearchDocumentHistoryFilterType.RENDER_HISTORY}
        colorPreset={colorPreset}
        onClick={() => onChange(SearchDocumentHistoryFilterType.RENDER_HISTORY)}
        testId="side_select-document_history-filter-prints_and_downloads"
      >
        Impressions & Téléchargements
      </SideSelectItem>
    </SideSelectContainer>
  )
}
